import React from 'react';
import { Button } from '@/components/ui/button';
import { PlusCircle } from 'lucide-react';
interface EditorAddBlockButtonProps {
  onAddBlock: () => void;
  className?: string;
}
const EditorAddBlockButton: React.FC<EditorAddBlockButtonProps> = ({
  onAddBlock,
  className
}) => {
  return;
};
export default EditorAddBlockButton;